import { Images } from "@assets/images";

function ComplaintHandlingPolicy() {
  return (
    <div className="bg-gray-100 min-h-screen flex justify-center py-8">
      <div className="px-10 py-8 bg-white shadow-md rounded-lg max-w-screen-lg mx-auto">
        <div className="flex justify-center mb-8">
          <img
            className="w-2/3 md:w-1/3"
            src={Images.LogoText.default}
            alt="Logo"
          />
        </div>
        <h1 className="text-3xl font-bold mb-4 text-gray-800 text-center">
          Chính sách xử lý khiếu nại
        </h1>
        <p className=" text-gray-600">
          <p className="my-2">
            – Tiếp nhận mọi khiếu nại của khách hàng liên quan đến việc sử dụng
            dịch vụ của công ty.
          </p>
          <p className="my-2">
            – Tất cả mọi trường hơp bảo hành, quý khách có thể liên hệ với chúng
            tôi để làm thủ tục bảo hành.
          </p>
          <p className="my-2">
            – Thời gian giải quyết khiếu nại trong thời hạn tối đa là 03 (ba)
            ngày làm việc kể từ khi nhận được khiếu nại của của khách hàng.
            Trong trường hợp bất khả kháng 2 bên sẽ tự thương lượng.
          </p>
          <p className="my-2 text-blue-400">
            <a
              href="https://bookas.vn/rules/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Xem thêm điều khoản sử dụng dịch vụ
            </a>
          </p>
        </p>
      </div>
    </div>
  );
}

export default ComplaintHandlingPolicy;
